function PageTitle (props) {

  return(
    <div style={{
         textAlign: 'center',
         color: '#fff',
         fontSize: '60px',
         fontWeight: '600',
         margin: '80px 0 15px 0',
       }}>
      {props.pageTitle}
    </div>
  )
}

export default PageTitle
